// Custom add-to-cart for Easify "Order fabric card" buttons
//
// Markup (in Easify):
//   <button type="button" data-handle="velvet-fabric-card" class="custom-add-to-cart">
//     Order velvet swatch card
//   </button>
//
// data-handle is preferred: the variant ID is looked up from the product, so a product ID
// can never be pasted by mistake and a recreated product picks up its new ID automatically.
// The legacy variant-id attribute still works as a fallback.
//
// Behaviour:
//   - Buttons for out-of-stock cards are relabelled and disabled on load.
//   - A 422 at click time (sold out between load and click) relabels rather than redirecting.
//   - Network failures still fall back to /cart, as before.

(function () {
  if (window.__ltSwatchInit) return;
  window.__ltSwatchInit = true;

  const OOS_LABEL = 'Sample card out of stock';
  const productCache = new Map();

  function getProduct(handle) {
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch('/products/' + handle + '.js')
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      );
    }
    return productCache.get(handle);
  }

  function markUnavailable(btn) {
    btn.textContent = OOS_LABEL;
    btn.setAttribute('disabled', '');
    btn.classList.add('is-unavailable');
  }

  // Tolerates a product ID pasted where a variant ID belongs. Safe while every swatch
  // card is a single "Default Title" variant.
  function resolveVariant(product, id) {
    if (id) {
      const match = product.variants.find((v) => v.id === id);
      if (match) return match;
      if (product.id === id && product.variants.length === 1) return product.variants[0];
      return null;
    }
    return product.variants[0] || null;
  }

  async function prepare(btn) {
    if (btn.dataset.ltReady) return;
    btn.dataset.ltReady = '1';

    const handle = btn.getAttribute('data-handle');
    const legacyId = Number(btn.getAttribute('variant-id')) || null;

    // No handle: nothing to check against, so leave the legacy ID in place and let the
    // click path handle it exactly as the old script did.
    if (!handle) {
      if (!legacyId) console.error('[swatch] button has neither data-handle nor variant-id', btn);
      return;
    }

    const product = await getProduct(handle);
    if (!product) {
      console.error('[swatch] product not found:', handle);
      return;
    }

    const variant = resolveVariant(product, legacyId);
    if (!variant) {
      console.error('[swatch] variant not found on', handle, legacyId);
      return;
    }

    if (variant.id !== legacyId) {
      console.warn('[swatch] resolved variant ID on', handle, legacyId, '->', variant.id);
      btn.setAttribute('variant-id', variant.id);
    }

    if (!variant.available) markUnavailable(btn);
  }

  function scan() {
    document.querySelectorAll('.custom-add-to-cart').forEach(prepare);
  }

  let queued = false;
  function queueScan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }

  // Easify injects its options after load, re-injects them on variant change, and the
  // easify:loaded handler in theme.liquid moves the buttons between containers.
  queueScan();
  document.addEventListener('DOMContentLoaded', queueScan);
  document.addEventListener('easify:loaded', queueScan);
  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.custom-add-to-cart');
    if (!btn || btn.hasAttribute('disabled')) return;

    e.preventDefault();

    const variantId = btn.getAttribute('variant-id');
    if (!variantId) return;

    btn.classList.add('loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.error('[swatch] add failed:', res.status, err);
        // 422 means unavailable — relabel rather than redirecting to an empty cart.
        if (res.status === 422) markUnavailable(btn);
        return;
      }

      // Trigger whatever cart system the theme uses
      document.dispatchEvent(new CustomEvent('updateCartD')); // your old theme event
      document.dispatchEvent(new CustomEvent('cart:refresh')); // common
      document.dispatchEvent(new CustomEvent('cart:updated')); // common
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true }) // Impact convention
      );

      // Open the cart drawer if the theme has a toggle
      const cartToggle = document.querySelector(
        '[data-cart-toggle], cart-drawer-toggle, a[href="/cart"]'
      );
      if (cartToggle) cartToggle.click();
    } catch (err) {
      // Genuine network failure only — 4xx is handled above and never reaches here.
      console.error('[swatch] add error:', err);
      window.location.href = '/cart';
    } finally {
      btn.classList.remove('loading');
    }
  });
})();